const REPLACEMENTS: Record<string, string> = {
  primary: 'text-primary',
  secondary: 'text-secondary',
}

export function colorizeTags(text: string | null | undefined): string {
  if (!text) return ''

  const escaped = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')

  return Object.entries(REPLACEMENTS).reduce((acc, [tag, className]) => {
    const re = new RegExp(`&lt;${tag}&gt;([\\s\\S]*?)&lt;\\/${tag}&gt;`, 'g')
    return acc.replace(re, `<span class="${className}">$1</span>`)
  }, escaped)
}
